import { gql } from '@apollo/client';
import { LanguageFragment } from 'graphql/Language/fragments/LanguageFragment';
/**
 * @fragment PriceListItemFragment
 * @since 1.0.0
 */
export const PriceListItemFragment = gql `
  fragment PriceListItemFragment on PriceListItem {
    id
    active
    cost
    price

    item {
      id
      sku
      title
      price
      cost
      image {
        image {
          url
        }
      }
      variants {
        id
      }
    }

    variant {
      id
      sku
      price
      cost
    }
  }
`;
/**
 * @fragment PriceListSummaryFragment
 * @since 1.0.0
 */
export const PriceListSummaryFragment = gql `
  fragment PriceListSummaryFragment on PriceList {
    id
    active
    entity
    entityId
    entityName
    title
    itemsCount
  }
`;
/**
 * @fragment PriceListFragment
 * @since 1.0.0
 */
export const PriceListFragment = gql `
  fragment PriceListFragment on PriceList {
    ...PriceListSummaryFragment
    infos
    translations {
      title
      infos
      createdAt
      updatedAt
      language {
        ...LanguageFragment
      }
    }

    items {
      ...PriceListItemFragment
    }
  }

  ${PriceListSummaryFragment}
  ${PriceListItemFragment}
  ${LanguageFragment}
`;
/**
 * Only what is needed to apply the prices of a list in a deal or an
 * agreement.
 * @fragment PriceListPricesFragment
 * @since 1.0.0
 */
export const PriceListPricesFragment = gql `
  fragment PriceListPricesFragment on PriceList {
    id
    title
    entity
    entityId
    active

    items {
      id
      active
      price
      item {
        id
      }
      variant {
        id
      }
    }
  }
`;
